import { render, staticRenderFns } from "./select-system.vue?vue&type=template&id=b799203e&scoped=true&"
import script from "./select-system.vue?vue&type=script&lang=js&"
export * from "./select-system.vue?vue&type=script&lang=js&"
import style0 from "./select-system.vue?vue&type=style&index=0&id=b799203e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b799203e",
  null
  
)

export default component.exports